import { ImageBannerType } from 'types/graphql';

export type ImageBannerTypeOption = {
  key: ImageBannerType;
  title: string;
  description: string;
};

/**
 * Defines the available image banner types with their display information
 */
export const imageBannerTypes: ImageBannerTypeOption[] = [
  {
    key: ImageBannerType.link,
    title: 'Link',
    description: 'Link to an external URL when clicked.',
  },
  {
    key: ImageBannerType.special,
    title: 'Special',
    description: 'Connect to a discount or special.',
  },
  {
    key: ImageBannerType.collection,
    title: 'Collection',
    description: 'Connect to a product collection.',
  },
  {
    key: ImageBannerType.category,
    title: 'Custom Category',
    description: 'Connect to a custom category.',
  },
];
